import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";
import { WarehouseAxios } from "api/WarehouseAxios";
import axios from "axios";
import { API_ENDPOINT } from "helpers/Endpoints/endpoints";

export const fetchWarehouseDropdown = createAsyncThunk(
  "unit/fetchWarehouseDropdown",
  async (warehouse_type?: string) => {
    const baseUrl = API_ENDPOINT.MASTERS.WAREHOUSE.CONFIGURATION.WAREHOUSE_BY_USER;
    if (warehouse_type) {
      const response = await Axios.get(
        `${baseUrl}?warehouse_type=${warehouse_type}`
      );
      return {
        data: response?.data || [],
      };
    } else {
      const response = await Axios.get(baseUrl);
      // localStorage.setItem('warehouseDropdownList',JSON.stringify(response?.data));

      return {
        data: response?.data || [],
      };
    }
  }
);
// export const fetchWarehouseDropdown2 = createAsyncThunk(
//   "unit/fetchWarehouseDropdown",
//   async (warehouse_type:string) => {
//     console.log("warehouse_type ",warehouse_type)
//     const response = await Axios.get(`/warehouse/user/warehouse/get_user/?warehouse_type=${warehouse_type}`);
//     // localStorage.setItem('warehouseDropdownList',JSON.stringify(response?.data));
//     console.log("Warehouse Dropdown Response", response?.data);
//     return {
//       data: response?.data || [],
//     };
//   }
// );

export const fetchWarehouseDropdown2 = createAsyncThunk(
  "unit/fetchWarehouseDropdown",
  async (warehouse_type: string) => {
    // console.log("warehouse_type ", warehouse_type);
    const baseUrl = API_ENDPOINT.MASTERS.WAREHOUSE.CONFIGURATION.WAREHOUSE_BY_USER;
    const response = await Axios.get(
      `${baseUrl}?warehouse_type=${warehouse_type}`
    );
    // const response = await Axios.get(`/warehouse/user/warehouse/get_user/?warehouse_type=${encodeURIComponent(
    //   warehouse_type
    // )}`
    // );

    return {
      data: response?.data || [],
    };
  }
);
